var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-points btn-reset",attrs:{"type":"button"}},[_c('span',{staticClass:"points"})])}]

export { render, staticRenderFns }